import _ from 'lodash';
import {
    FETCH_MTOKNA_CAMPAIGNS,
    CLEAN_MTOKNA_CAMPAIGNS,
    DELETE_MTOKNA_CAMPAIGN,
} from './types';
import {request, __} from '../functions';

export const fetchMtoknaCampaigns = (screen, options = {}) => {
    const defaults = {
        page: 1,
        per_page: 0,
        filtered: {},
        callback: null,
    };

    options = { ...defaults, ...options };

    let params = { page: options.page, per_page: options.per_page };

    // Nasetujeme filter
    _.forEach(options.filtered, (value, key) => {
        params = { ...params, ...{ [`filter_${key}`]: value } };
    });

    return dispatch => request('/mtokna/campaigns', params).then(response => {
        const { data, sync } = response.data;
        const { setUser } = screen.props;

        if (options.callback !== null) {
            // Zavolame callback
            options.callback();
        }

        // Nasetujeme user data
        setUser(sync.user);

        dispatch({ type: FETCH_MTOKNA_CAMPAIGNS, payload: data });
    });
};

export const cleanMtoknaCampaigns = () => ({ type: CLEAN_MTOKNA_CAMPAIGNS });

export const deleteMtoknaCampaign = (screen, id) => {
    return dispatch => request(`/mtokna/removeCampaign/${id}`).then(response => {
        const { status } = response.data;

        if (status === 'error') {
            screen.showSnackbar('error', __('Kampaň sa nepodarilo zmazať'));
            return;
        }

        screen.showSnackbar('success', __('Kampaň bola zmazaná'));

        dispatch({ type: DELETE_MTOKNA_CAMPAIGN });
    });
};
